import { Scene, StandardMaterial, Texture } from '@babylonjs/core';

export class TextureMaterial extends StandardMaterial {
    public constructor(name: string, scene: Scene, textureUrl: string) {
        super(name, scene);

        this.disableDepthWrite = true;
        this.fogEnabled = false;

        this.emissiveTexture = new Texture(textureUrl, scene);
        this.emissiveTexture.wrapU = Texture.CLAMP_ADDRESSMODE;
        this.emissiveTexture.wrapV = Texture.CLAMP_ADDRESSMODE;
    }
}
